import { FunctionComponent, useCallback, useEffect, useState } from 'react'
import { MdCheck } from 'react-icons/md'
import { useHistory, useLocation } from 'react-router-dom'

import ETipoVeiculo from 'modules/veiculos/domain/entities/ETipoVeiculo'
import Autocomplete from 'shared/components/Autocomplete'
import ContainerPage from 'shared/components/ContainerPageNew'
import { Feedback } from 'shared/components/Feedback'
import InputFile from 'shared/components/InputFile'
import Modal from 'shared/components/Modal'
import Radio from 'shared/components/Radio'
import SizedBox from 'shared/components/SizedBox'
import SnackBar from 'shared/components/SnackBar'
import Text from 'shared/components/Text'
import { registerEvent } from 'shared/services/TrackingGAService'
import { colors } from 'shared/styles/colors'
import { validateTypeFile } from 'shared/utils/validates'

import iconConcluido from 'shared/assets/icons/icon-concluido-blue.png'
import TipoCarreta from '../../domain/entities/TipoCarreta'
import { ICreateVeiculos } from '../../domain/usecases/CreateVeiculos'
import { IListTipoCarretas } from '../../domain/usecases/ListTipoCarretas'
import VeiculoRoutes from '../../utils/VeiculoRoutes'
import { ContainerCavalo, ContainerCarreta } from './styles'
import { useFrotista } from 'modules/user/hooks/useFrotista'
import ModalSelectFrotista from 'shared/components/ModalSelectFrotista'
import ModalAnttRecusada from 'shared/components/ModalAnttRecusada'
import { IValidateAntt } from 'modules/user/domain/usecases/ValidateAnttImpl'

interface ILocation {
  origem?: string
}
type TProps = {
  listTipoCarretas: IListTipoCarretas
  createVeiculos: ICreateVeiculos
  validateAntt: IValidateAntt
}
const CreateVeiculo: FunctionComponent<TProps> = ({
  listTipoCarretas,
  createVeiculos,
  validateAntt,
}) => {
  const location = useLocation<ILocation>()
  const history = useHistory()
  const origem = location?.state?.origem
  let handleClickBack
  if (origem === VeiculoRoutes.LIST) {
    handleClickBack = () => history.goBack()
  }

  const [openAlert, setOpenAlert] = useState(false)
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [openModal, setOpenModal] = useState(false)

  const [tipoCarretas, setTipoCarretas] = useState<TipoCarreta[]>([])
  const [tipoCarreta, setTipoCarreta] = useState<TipoCarreta>()
  const [type, setType] = useState('')
  const [isDisable, setIsDisable] = useState(true)
  const [base64, setBase64] = useState('')
  const [isWrongExtension, setIsWrongExtension] = useState(false)
  const [fileName, setFileName] = useState<string>()
  const { frotistaId, frotista } = useFrotista()
  const [openModalSelectFrotista, setOpenModalSelectFrotista] = useState(false)
  const [openModalAntt, setOpenModalAntt] = useState(false)
  const [modalAnttParams, setModalAnttParams] = useState({
    message: '',
    bloquearAnttNaoValida: true,
  })

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true)
        const response = await listTipoCarretas.execute()
        if (response) {
          setTipoCarretas(response)
        }
      } catch (error: unknown) {
        if (error instanceof Error) {
          setErrorMessage(error.message)
        } else {
          setErrorMessage('Erro ao tentar buscar os tipos de carreta')
        }
        setOpenAlert(true)
      } finally {
        setLoading(false)
      }
    }
    if (tipoCarretas.length === 0) {
      fetchData()
    }
  }, [type, listTipoCarretas, tipoCarretas])

  const handleCreateVeiculos = async () => {
    try {
      setLoading(true)
      await createVeiculos.execute({
        crlv_imagem_completa: base64,
        tipo: type,
        tipo_carreta_id: tipoCarreta?.id,
        frotista_id: frotistaId,
      })
      setOpenModal(true)
    } catch (error: unknown) {
      if (error instanceof Error) {
        setErrorMessage(error.message)
      } else {
        setErrorMessage('Erro ao inserir veículo.')
      }
    } finally {
      setLoading(false)
    }
  }

  const handleCreate = async () => {
    if (!frotistaId) {
      setOpenModalSelectFrotista(true)
      return
    }
    registerEvent({
      categoria: 'Cadastro de Veículo',
      acao: 'Click Salvar ',
      local: 'Tela final do cadastro de veículo',
    })
    try {
      setLoading(true)
      const anttResponse = await validateAntt.execute({
        cnpj: frotista?.cnpj,
        antt: frotista?.antt,
      })
      if (!anttResponse?.aptoTransporte) {
        setOpenModalAntt(true)
        setModalAnttParams({
          message: anttResponse.mensagem,
          bloquearAnttNaoValida: anttResponse?.bloquearAnttNaoValida,
        })
      } else {
        await handleCreateVeiculos()
      }
    } catch (error: unknown) {
      if (error instanceof Error) {
        setErrorMessage(error.message)
      } else {
        setErrorMessage('Erro ao tentar criar novo veículo')
      }
      setOpenAlert(true)
    } finally {
      setLoading(false)
    }
  }

  const handleInputFile = useCallback((base64, fileName: string) => {
    setFileName(fileName)
    if (validateTypeFile(fileName)) {
      setIsWrongExtension(false)
      setIsDisable(false)
      setBase64(base64)
    } else {
      setIsWrongExtension(true)
      setIsDisable(true)
    }
  }, [])

  const handleFeedbackClick = useCallback(() => {
    window.location.reload()
  }, [])

  return (
    <ContainerPage
      breadCrumb="Veículos / Adicionar de veículos"
      showFooterScaffold={true}
      onClickNextButton={handleCreate}
      titleNextButton="Salvar"
      iconButtonNext={MdCheck}
      colorNextButton={isDisable ? colors.grayLight : undefined}
      titleBackButton={origem === VeiculoRoutes.LIST ? 'Voltar' : null}
      onClickBackButton={handleClickBack}
      title="Tipo de veículo"
      titleHeader="Novo veículo"
      isNextButtonDisabled={isDisable}
      loading={loading}
    >
      <Text>Qual é o tipo de veículo</Text>
      <Radio
        id="cavalo"
        label="Cavalo"
        name="type"
        value="CAVALO"
        onChange={setType}
      />
      <Radio
        id="carreta"
        label="Carreta"
        name="type"
        value="CARRETA"
        onChange={setType}
      />
      {type === '' ? (
        ''
      ) : type === ETipoVeiculo.CAVALO ? (
        <ContainerCavalo>
          <Text>Envie uma foto do documento do veículo</Text>
          <InputFile
            id="doc-veiculo-cavalo"
            onSelectFile={handleInputFile}
            colorFileText={colors.blue}
            isWrongExtension={isWrongExtension}
            file={fileName}
          />
        </ContainerCavalo>
      ) : (
        <ContainerCarreta>
          <Autocomplete
            label="Qual é o tipo de carreta?"
            placeholder="Digite para buscar ou selecione na lista"
            options={tipoCarretas}
            onChange={(_, newValue) => setTipoCarreta(newValue)}
            getOptionLabel={option => (option as TipoCarreta).descricao}
          />
          <SizedBox size={30} />
          {tipoCarreta && (
            <>
              <Text>Envie uma foto do documento do veículo</Text>
              <InputFile
                id="doc-veiculo-carreta"
                onSelectFile={handleInputFile}
                colorFileText={colors.blue}
                isWrongExtension={isWrongExtension}
                file={fileName}
              />
            </>
          )}
        </ContainerCarreta>
      )}

      {frotistaId && (
        <Text style={{ marginTop: 30 }}>
          CNPJ Selecionado: <strong>{frotista?.cnpj}</strong>
        </Text>
      )}

      <SnackBar
        open={openAlert}
        setOpen={setOpenAlert}
        severity="error"
        message={errorMessage}
      />
      <Modal size="small" openModal={openModal} showCloseButton={false}>
        <Feedback
          color={colors.blue}
          icon={iconConcluido}
          showLogo={false}
          title="Solicitação de cadastro efetuada com sucesso!"
          sizeIcon={70}
          onClickButton={handleFeedbackClick}
          subTitle="Estamos analisando os dados e em breve retornaremos."
          backgroundColor={colors.white}
        />
      </Modal>

      <ModalSelectFrotista
        openModalSelectFrotista={openModalSelectFrotista}
        setOpenModalSelectFrotista={setOpenModalSelectFrotista}
      />
      <ModalAnttRecusada
        openModal={openModalAntt}
        setOpenModal={setOpenModalAntt}
        onConfirm={handleCreateVeiculos}
        params={modalAnttParams}
      />
    </ContainerPage>
  )
}

export default CreateVeiculo
